import { Component, AfterViewInit } from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../auth.service';
import {CookieService} from 'ngx-cookie-service';
import {Router} from '@angular/router';
import {LayoutManagerService} from '../../../layout-manager.service';
import {environment} from '../../../../environments/environment';
declare var $: any;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit {

  public showSearch = false;

  authService: AuthService
  layoutManager: LayoutManagerService

  constructor(private modalService: NgbModal,
              authService: AuthService,
              private cookieService: CookieService,
              private router:Router,
              layoutManager: LayoutManagerService) {
    this.layoutManager = layoutManager
    this.authService = authService
  }

  logout() {
    this.cookieService.delete( 'email');
    this.cookieService.delete( 'password');
    this.cookieService.deleteAll('/','assetstore.assetx.it')
    this.cookieService.deleteAll()
    console.log(this.cookieService.get('email'))
    console.log(this.cookieService.get('password'))
    this.authService.doSignOutUser();
    window.location.replace(environment.host+'login')
  }

  ngAfterViewInit() {}
}
